/**
 * Type for a orientation.
 */
export enum Orientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

/**
 * Interface for extending with a single 'orientation' property.
 */
export interface OrientationProp {
  /**
   * The {@link Orientation}.
   */
  orientation?: Orientation;
}
